import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * ForgeAriaFab — sfera fluttuante "A" (Aria Kernel) sempre presente
 * su tutte le sezioni Forge (Workspace, Cockpit Aria, Universe, Memory,
 * Providers, Bench). Al click naviga al Cockpit Aria per la chat completa.
 *
 * Replica visuale del FAB server-rendered in Forge Console (`server.py`),
 * così l'esperienza utente è identica in tutta l'app.
 */
const FORGE_PATHS = ["/forge", "/universe", "/memory", "/providers", "/bench"];

export default function ForgeAriaFab() {
  const location = useLocation();
  const navigate = useNavigate();

  // Mostra solo dentro l'ecosistema Forge (non su homepage marketing).
  const path = location.pathname || "";
  const inForgeArea = FORGE_PATHS.some(p => path === p || path.startsWith(p + "/"));
  if (!inForgeArea) return null;

  // Sul Cockpit Aria stesso non serve un altro FAB.
  if (path === "/forge/aria" || path.startsWith("/forge/aria/")) return null;

  return (
    <button
      type="button"
      onClick={() => navigate("/forge/aria")}
      data-testid="forge-aria-fab-global"
      className="forge-aria-fab-global"
      title="Apri Aria Cockpit"
      aria-label="Apri Aria Cockpit"
      style={{
        position: "fixed",
        right: 20,
        bottom: 20,
        width: 56,
        height: 56,
        borderRadius: "50%",
        background: "linear-gradient(135deg, #8b5cf6, #22d3ee)",
        color: "#fff",
        fontSize: 22,
        fontWeight: 700,
        border: "none",
        cursor: "pointer",
        boxShadow: "0 8px 24px rgba(139,92,246,0.45)",
        display: "grid",
        placeItems: "center",
        zIndex: 2147482500,
        transition: "transform 0.15s",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.transform = "translateY(-2px) scale(1.05)")}
      onMouseLeave={(e) => (e.currentTarget.style.transform = "none")}
    >
      A
    </button>
  );
}
